import React from 'react';
import { Gift } from 'lucide-react';
const bonuses = [{
  title: 'BONO 1 — Banco de Juegos Musicales Premium',
  desc: '50 dinámicas listas para motivar, ordenar el aula y hacer música sin caos.',
  img: 'https://cdn.magicpatterns.com/uploads/9t8iae76pcBiAoXkHPZUeM/bono1.png'
}, {
  title: 'BONO 2 — Kit Ritmo y Percusión Corporal',
  desc: '30 secuencias listas para enseñar ritmo con progresión real, incluso sin instrumentos.',
  img: 'https://cdn.magicpatterns.com/uploads/puGoSDEU3zpsZ2bEwkfEHR/bono2.png'
}, {
  title: 'BONO 3 — Evaluaciones Premium',
  desc: 'Más de 40 instrumentos de evaluación. Listas de cotejo, rúbricas, pruebas rápidas y autoevaluación.',
  img: 'https://cdn.magicpatterns.com/uploads/jbY2HcgcoYGQbpvDgLLwVp/bono3.png'
}, {
  title: 'BONO 4 — Planificación Perfecta Música',
  desc: 'Calendario anual + secuencias didácticas + planificaciones editables.',
  img: 'https://cdn.magicpatterns.com/uploads/1rpSsngMxowkHFcrTFUgT3/bono4.png'
}];
export const BonusSection: React.FC = () => {
  return <section className="py-16 bg-purple-900 text-white" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <span className="inline-flex items-center justify-center p-3 bg-purple-800 rounded-full mb-4" data-id="element-4">
            <Gift className="h-8 w-8 text-yellow-400" data-id="element-5" />
          </span>
          <h2 className="text-3xl font-extrabold sm:text-4xl" data-id="element-6">
            Bonos incluidos
          </h2>
          <p className="mt-4 text-xl text-purple-200" data-id="element-7">
            Para que el año quede aún más resuelto (GRATIS por hoy)
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-8">
          {bonuses.map((bonus, index) => <div key={index} className="bg-purple-800 rounded-xl overflow-hidden shadow-xl transform transition hover:-translate-y-1" data-id="element-9">
              <div className="p-1 bg-gradient-to-r from-yellow-400 to-orange-500" data-id="element-10">
                <div className="bg-purple-900 py-1 text-center font-bold text-xs uppercase tracking-wide text-white" data-id="element-11">
                  Gratis hoy
                </div>
              </div>
              <img src={bonus.img} alt={bonus.title} className="w-full h-64 object-contain bg-purple-800/50 p-4" data-id="element-12" />
              <div className="p-6" data-id="element-13">
                <h3 className="text-lg font-bold text-white mb-2" data-id="element-14">
                  {bonus.title}
                </h3>
                <p className="text-purple-200 text-sm" data-id="element-15">{bonus.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};